import { SxProps, Theme } from '@mui/material/styles'
import { typography } from '@hapana/shared/web/styles/material-ui/typography'

const baseText: SxProps<Theme> = {
  ...typography.medium,
  fontStyle: 'normal',
  lineHeight: '20px',
}

const semiBoldText: SxProps<Theme> = {
  ...typography.header4,
  fontStyle: 'normal',
  lineHeight: '20px',
}

export const hoverBaseStyles = {
  root: {
    mt: 1,
  } as SxProps<Theme>,

  textRegular: {
    ...baseText,
  } as SxProps<Theme>,

  textSemiBold: semiBoldText,
}
